import React from 'react'


function Dot() {
  return (<div className="dot" />)
}
function Column(props) {
  return (<div className="column">{props.children}</div>)
}

function Face (props) {
  const idx = props.idx
  const list = []
  if (idx === 4 ) {
    for (let col = 0; col < 2 ; col++) {
      const children = []
      for (let i = 0 ; i < 2; i++) children.push(<Dot key={i} />);
      list.push(<Column key={col}>{children}</Column>);
    }
  } else if (idx === 5 ) {
    for (let col = 0; col < 3 ; col++) {
      const children = []
      if (col === 1) {
        children.push(<Dot key={1} />)
      }else {
        for (let i = 0 ; i < 2; i++) children.push(<Dot key={i} />);
      }
      list.push(<Column key={col}>{children}</Column>);
    }
  }
  else if (idx === 6 ) {
    for (let col = 0; col < 2 ; col++) {
      const children = []
      for (let i = 0 ; i < 3; i++) children.push(<Dot key={i} />);
      list.push(<Column key={col}>{children}</Column>);
    }
  } else {
    for (let i = 0 ; i < idx; i++) {
      list.push(<Dot key={i} />)
    }
  }

  return(<div className={ (props.className || ('side side-' + idx)) }>
    {list}
  </div>)
}

export class DiceComponent extends React.Component {
  render(){
    return (
        <div className={'dice up-' + this.props.faceUp} onClick={this.roll}>
          <Face idx={1} />
          <Face idx={2} />
          <Face idx={3} />
          <Face idx={4} />
          <Face idx={5} />
          <Face idx={6} />
        </div>
    )
  }
}

export class DiceFlatComponent extends React.Component {
  render(){
    const idx = this.props.faceUp
    return (<div className={'dice-flat ' + (this.props.className || '') }>
      <Face className={'face-' + idx } idx={idx} />
    </div>)
  }
}


export class DiceWrapper extends React.Component {
  constructor(){
    super()
    this.state = {
      faceUp: 1
    }
  }
  roll = () => {
    const faceUp = Math.round(Math.random()*6)
    this.setState({faceUp})
  }
  render(){

    return (
        <div className="dice-wrapper" onClick={this.roll}>
          <DiceComponent faceUp={this.state.faceUp} />
        </div>
    )
  }
}
export default DiceWrapper


// WEBPACK FOOTER //
// ./src/game/dice/components/DiceComponent.jsx